import Http from "nw-micro-http";
import { Utils } from "nw-micro-core";
import qs from "qs";

//统一格式化
export const stringify = (params) => {
  return qs.stringify(params, { allowDots: true, indices: false });
};

export const formContentType = {
  "content-type": "application/x-www-form-urlencoded",
};

export const jsonContentType = {
  "content-type": "application/json;charset=UTF-8",
};

export const multipartContentType = {
  "content-type": "multipart/form-data",
};

export const requestProxy = {
  api: process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_PROXY,
};

const timeout = 36 * 1000; // 36秒

const options = {
  axiosOptions: {
    headers: { ...formContentType, isVue: 1, ssoLogin: 1 },
    timeout: timeout,
    withCredentials: true,
  },
  requestInterceptorSuccessCb: (config) => {
    let params = config.data;
    if (
      Utils.isNotEmpty(params) &&
      config.headers["content-type"] === formContentType["content-type"]
    ) {
      config.data = stringify(params);
    }
    return config;
  },
  responseInterceptorSuccessCb: (res) => {
    // if (
    //   res.config.responseType !== "blob" &&
    //   !res?.data?.result?.success &&
    //   !res.data.success &&
    //   res.config.baseURL !== process.env.VUE_APP_OLD_API_PROXY &&
    //   res.config.baseURL !== process.env.VUE_APP_APPLY_API_PROXY
    // ) {
    //   let uri = res.config.url;
    //   if (
    //     uri.indexOf("getProvinceLoginToken") !== -1 ||
    //     uri.indexOf("thirdPartyLogin") !== -1
    //   ) {
    //     return res;
    //   }
    //   Message({
    //     showClose: true,
    //     message: res?.data?.result?.errMsg || "服务器异常。请求失败！",
    //     type: "error",
    //   });
    // }
    // if (res.config.responseType !== "blob" && res?.data?.errCode === "20041") {
    //   Message({
    //     showClose: true,
    //     message: res?.data?.errMsg || "入参中有非法字符!",
    //     type: "error",
    //   });
    // }
    return res;
  },
  responseInterceptorErrorCb: (err) => err,
};

const http = new Http(options);

export default http;
